import { Controller } from "@hotwired/stimulus"
import imageCompression from "browser-image-compression"

export default class extends Controller {
  static targets = ["input"]
  static values = {
    maxSizeMb: { type: Number, default: 1 },
    maxWidthOrHeight: { type: Number, default: 3000 },
    submitOnChange: { type: Boolean, default: true }
  }

  chooseCamera(event) {
    this.openPicker(event, "environment")
  }

  chooseGallery(event) {
    this.openPicker(event)
  }

  async compressAndSubmit(event) {
    const inputElement = event.target
    const file = inputElement.files?.[0]
    if (!file) return

    if (!file.type?.startsWith("image/")) {
      if (this.submitOnChangeValue) this.element.requestSubmit()
      return
    }

    try {
      const compressedOutput = await imageCompression(file, {
        maxSizeMB: this.maxSizeMbValue,
        maxWidthOrHeight: this.maxWidthOrHeightValue,
        useWebWorker: true
      })

      const compressedFile = compressedOutput instanceof File
        ? compressedOutput
        : new File([compressedOutput], file.name, {
            type: compressedOutput.type || file.type,
            lastModified: Date.now()
          })

      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(compressedFile)
      inputElement.files = dataTransfer.files
    } catch (error) {
      console.error("[photo-upload-compression] compression failed", error)
    }

    if (this.submitOnChangeValue) this.element.requestSubmit()
  }

  openPicker(event = null, capture = null) {
    const input = this.inputForEvent(event)
    if (!input) return

    if (capture) {
      input.setAttribute("capture", capture)
    } else {
      input.removeAttribute("capture")
    }

    input.click()
  }

  inputForEvent(event) {
    const picker = event?.currentTarget?.closest("[data-upload-picker]")
    if (picker) {
      return picker.querySelector('input[type="file"][data-photo-upload-compression-target="input"]')
    }

    return this.hasInputTarget ? this.inputTarget : null
  }
}
